module.exports = __webpack_public_path__ + "static/media/people1.ed3a84fc.jpeg";